var map = {
	"./auth.js": "c7d4",
	"./cart.js": "499b",
	"./comment.js": "f07f",
	"./coupon.js": "a48b",
	"./deposit.js": "89bf",
	"./global.js": "8303",
	"./loading.js": "121d",
	"./merchant.js": "e6df",
	"./order.js": "2bf4",
	"./set.js": "51ea",
	"./spa.js": "b695",
	"./wordpress.js": "458e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c3e1";